var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHelp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0.5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,0A9,9,0,0,0,1.194,13.48l-1.16,3.6a.7.7,0,0,0,.885.885l3.6-1.16A9,9,0,1,0,9,0Zm.879,9A.879.879,0,1,1,9,8.121.879.879,0,0,1,9.879,9Zm3.516,0a.879.879,0,1,1-.879-.879A.879.879,0,0,1,13.395,9ZM6.363,9a.879.879,0,1,1-.879-.879A.879.879,0,0,1,6.363,9Zm0,0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/help.9087ac07.svg";
export { ForwardRef as ReactComponent };